<app-header [isSticky]="isSticky"></app-header>
<router-outlet></router-outlet>
<ng-http-loader
  [backdrop]="true"
  [backgroundColor]="'black'"
  [spinner]="spinnerStyle.skThreeBounce">
  </ng-http-loader>
<app-footer></app-footer> 
